export default class ProjectUnitsService {
  public buildUrl(
      id: string,
      page: number,
      operationType: string,
      publisherId: string,
      projectPagePath: String = "project",
      isNewDevelopment?: boolean
  ): string {
    const search: string = window.location.search;
    const isNewDevelopmentQueryParam: string = isNewDevelopment
        ? `${search.startsWith("?") ? '&' : '?'}newDevelopment=${isNewDevelopment}`
        : '';
    return publisherId
        ? `/${projectPagePath}/${id}/${operationType}/${page}/${publisherId}${search}${isNewDevelopmentQueryParam}`
        : `/${projectPagePath}/${id}/${operationType}/${page}${search}${isNewDevelopmentQueryParam}`;
  }

  public async getProjectUnits(id: string,
                               page: number,
                               operationType: string,
                               publisherId: string,
                               projectPagePath: String = "project",
                               isNewDevelopment?: boolean) {
    const url: string = this.buildUrl(id, page, operationType, publisherId, projectPagePath, isNewDevelopment);
    const request = await fetch(url, {
      method: 'GET'
    });
    return request.text();
  }
}
